<template>
  <el-form-item label="开通员工管理："
                prop="staffVendorDataScope">
    <el-radio-group :value="staffVendorDataScope"
                    @change="handleChange">
      <el-radio-button :label="1">已开通</el-radio-button>
      <el-radio-button :label="0">未开通</el-radio-button>
    </el-radio-group>
  </el-form-item>
</template>

<script>
import Supervise from '@/service/supervise'
export default {
  name: 'staff-vendor-data-scope',
  props: {
    orginazation: { type: Object, default: () => {} },
    staffVendorDataScope: { type: Number, default: 1 }
  },
  data () {
    return { loading: false }
  },
  methods: {
    handleChange (e) {
      console.log(e)
      const open = e === 0
      const title = open ? '打开' : '关闭'
      this.$confirm(`此操作将${title}该二级机构的员工管理, 是否继续?`, '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      })
        .then(() => {
          this.loading = true
          Supervise.configstaffvendordatascope({ open, regulatorId: this.orginazation.regulatorId })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if (result === 0) {
                this.$message.success(title + '成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              console.log(err)
              this.$message.error(err.message)
            })
        })
    }
  }
}
</script>
